import FullWidthCarousel from 'app/(web)/components/product/fullWidthCarousel';
import { Product } from 'app/types/product';
import { Container, Flex } from 'designSystem/Layouts/Layouts';
import { Title } from 'designSystem/Texts/Texts';

export default function AestheticProductStepByStep({
  product,
  isMobile,
  isModal = false,
}: {
  product: Product;
  isMobile: boolean;
  isModal?: boolean;
}) {
  const orderedTreatmentProcess =
    product.treatmentProcess?.sort((a, b) => a.order - b.order) || [];

  if (orderedTreatmentProcess.length === 0) return <></>;

  return (
    <div className="py-12">
      <Container>
        <Title isAnimated size="2xl" className="font-bold mb-8 md:mb-12">
          Paso a paso
        </Title>
      </Container>

      {isMobile && (
        <Container>
          {orderedTreatmentProcess.map((step, index) => (
            <ul className="flex flex-col pl-4" key={step.title}>
              <li
                key={step.title}
                className="border-l-2 border-hg-cream relative p-8 pt-0"
              >
                <Flex className="justify-center items-center absolute top-0 left-0 w-8 h-8 aspect-square bg-hg-cream rounded-full text-hg-secondary font-semibold -translate-x-1/2 pt-1">
                  {index + 1}
                </Flex>
                <p className="font-semibold mb-2">{step.title}</p>
                <p className="text-sm">{step.description}</p>

                {index + 1 === orderedTreatmentProcess.length && (
                  <span className="absolute h-2 w-2 bg-hg-cream rotate-45 bottom-0 left-0 -translate-x-1/2" />
                )}
              </li>
            </ul>
          ))}
        </Container>
      )}

      {!isMobile && (
        <FullWidthCarousel
          visibleSlides={3.5}
          disableLeftMargin={isModal}
          customLeftMargin={isModal ? 32 : null}
        >
          {orderedTreatmentProcess.map((step, index) => (
            <div key={step.title} className="pt-4">
              <Flex
                layout="col-left"
                key={step.title}
                className="border-t-2 border-hg-cream relative pt-12 pr-12"
              >
                <Flex className="justify-center items-center absolute top-0 left-0 w-8 h-8 aspect-square bg-hg-cream rounded-full text-hg-secondary -translate-y-1/2 pt-1">
                  {index + 1}
                </Flex>
                <p className="font-semibold mb-2 text-lg">{step.title}</p>
                <p>{step.description}</p>

                {index + 1 === orderedTreatmentProcess.length && (
                  <span className="absolute h-2 w-2 bg-hg-cream rotate-45 top-0 right-0 -translate-y-1/2" />
                )}
              </Flex>
            </div>
          ))}
        </FullWidthCarousel>
      )}
    </div>
  );
}
